module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForWin_pic11.d95a926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForWin/dataLeakInstallForWin_pic11.png
// module id = 490
// module chunks = 1